// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.consumption-chart-container {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.chart-header {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-md);
  margin-bottom: var(--spacing-lg);
}

.chart-title-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.5rem;
}

.chart-title-row h4 {
  font-size: var(--font-size-lg);
  color: var(--color-secondary);
  font-weight: 600;
  margin: 0;
  letter-spacing: -0.02em;
}

.chart-controls {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.year-selector {
  padding: var(--spacing-sm) var(--spacing-md);
  font-size: var(--font-size-sm);
  font-weight: 600;
  color: var(--color-secondary);
  background: var(--color-card-bg);
  border: 2px solid var(--color-border);
  border-radius: var(--radius-sm);
  cursor: pointer;
  transition: all var(--transition-base);
  box-shadow: var(--shadow-sm);
}

.year-selector:hover {
  border-color: var(--color-gray-300);
  transform: translateY(-1px);
  box-shadow: var(--shadow-md);
}

.year-selector:focus {
  outline: none;
  border-color: var(--color-primary);
  box-shadow: 0 0 0 3px rgba(255, 107, 53, 0.2);
}

.environment-toggle {
  display: flex;
  gap: var(--spacing-xs);
  padding: var(--spacing-xs);
  background: var(--color-bg-secondary);
  border-radius: var(--radius-md);
  border: 1px solid var(--color-border);
}

.env-btn {
  padding: var(--spacing-sm) var(--spacing-md);
  font-size: var(--font-size-sm);
  font-weight: 600;
  color: var(--color-text-primary);
  background: transparent;
  border: none;
  border-radius: var(--radius-sm);
  cursor: pointer;
  transition: all var(--transition-base);
  position: relative;
}

.env-btn:hover {
  color: var(--color-primary);
  background: var(--color-hover-bg);
}

.env-btn.active {
  color: white;
  background: var(--color-secondary-dark);
  box-shadow: var(--shadow-sm);
}

.env-btn.active:hover {
  background: #1a3a5c;
}

.usage-info {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.usage-stats {
  display: flex;
  align-items: baseline;
  gap: 0.5rem;
  flex-wrap: wrap;
}

.year-stats {
  display: flex;
  align-items: baseline;
  gap: 0.5rem;
  margin-top: 0.5rem;
  padding-top: 0.5rem;
  border-top: 1px solid var(--color-border);
}

.usage-label {
  font-size: var(--font-size-sm);
  color: var(--color-text-secondary);
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.usage-value {
  font-size: var(--font-size-base);
  font-weight: 700;
  color: var(--color-secondary);
}

.usage-value.approaching-limit {
  color: var(--color-warning);
}

.usage-value.over-limit {
  color: var(--color-danger);
}

.usage-percentage {
  font-size: var(--font-size-lg);
  font-weight: 700;
  color: var(--color-success);
}

.usage-percentage.approaching-limit {
  color: var(--color-warning);
}

.usage-percentage.over-limit {
  color: var(--color-danger);
}

.usage-alert {
  display: flex;
  align-items: center;
  gap: var(--spacing-sm);
  padding: var(--spacing-md) var(--spacing-lg);
  border-radius: var(--radius-md);
  font-size: var(--font-size-sm);
  font-weight: 600;
  animation: slideIn var(--transition-slow) ease-out;
  box-shadow: var(--shadow-sm);
}

.usage-alert.warning {
  background: #fef3c7;
  color: #92400e;
  border: 1px solid #fcd34d;
}

.usage-alert.critical {
  background: #fee2e2;
  color: #991b1b;
  border: 1px solid #fca5a5;
}

.usage-alert svg {
  flex-shrink: 0;
}

@keyframes slideIn {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.time-toggle {
  display: flex;
  gap: var(--spacing-xs);
  padding: var(--spacing-xs);
  background: var(--color-bg-secondary);
  border-radius: var(--radius-md);
  align-self: flex-end;
  border: 1px solid var(--color-border);
}

.toggle-btn {
  padding: var(--spacing-sm) var(--spacing-md);
  font-size: var(--font-size-sm);
  font-weight: 600;
  color: var(--color-text-primary);
  background: transparent;
  border: none;
  border-radius: var(--radius-sm);
  cursor: pointer;
  transition: all var(--transition-base);
}

.toggle-btn:hover {
  color: var(--color-primary);
  background: var(--color-hover-bg);
}

.toggle-btn.active {
  color: white;
  background: var(--color-secondary-dark);
  box-shadow: var(--shadow-sm);
}

.toggle-btn.active:hover {
  background: #1a3a5c;
}

.chart-container {
  flex: 1 1;
  position: relative;
  min-height: 300px;
  background: var(--color-bg-secondary);
  border-radius: var(--radius-md);
  padding: var(--spacing-lg);
  border: 1px solid var(--color-border);
}

.chart-container canvas {
  max-height: 350px;
}

.chart-footer {
  display: flex;
  gap: 2rem;
  margin-top: 1rem;
  padding-top: 1rem;
  border-top: 1px solid var(--color-border);
}

.threshold-indicator {
  display: flex;
  align-items: center;
  gap: var(--spacing-sm);
  font-size: var(--font-size-xs);
  color: var(--color-text-secondary);
  font-weight: 500;
}

.threshold-line {
  width: 24px;
  height: 3px;
  border-radius: 1px;
}

.threshold-line.warning {
  background: var(--color-warning);
  box-shadow: 0 0 4px rgba(245, 158, 11, 0.5);
}

.threshold-line.critical {
  background: var(--color-danger);
  box-shadow: 0 0 4px rgba(239, 68, 68, 0.5);
}

.threshold-label {
  font-weight: 500;
}

/* New component styles */
.consumption-container {
  background: var(--color-card-bg);
  padding: 24px;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  height: 100%;
  display: flex;
  flex-direction: column;
}

.consumption-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.consumption-header h3 {
  font-size: 18px;
  font-weight: 600;
  color: var(--color-text-primary);
  margin: 0;
}

.year-selector-container {
  display: flex;
  align-items: center;
}

.no-data-message {
  text-align: center;
  color: var(--color-text-secondary);
  padding: 40px 20px;
  font-size: 14px;
}

.usage-stat {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  padding: 8px 0;
}

.usage-value.danger {
  color: #dc3545;
}

.usage-value.warning {
  color: #f59e0b;
}

.usage-value.success {
  color: #28a745;
}

.usage-value.neutral {
  color: #6b7280;
}

.usage-value.info {
  color: #3b82f6;
  font-style: italic;
}

.trend-detail {
  font-size: 12px;
  color: var(--color-text-secondary);
  margin-left: 4px;
}

.consumption-alert {
  border-radius: 8px;
  padding: 12px 16px;
  margin-bottom: 16px;
  display: flex;
  gap: 12px;
  align-items: start;
}

.consumption-alert.danger {
  background: #fee2e2;
  border: 1px solid #fca5a5;
  color: #991b1b;
}

.consumption-alert.info {
  background: #dbeafe;
  border: 1px solid #93c5fd;
  color: #1e40af;
}

.consumption-alert.success {
  background: #dcfce7;
  border: 1px solid #86efac;
  color: #14532d;
}

.consumption-alert.warning {
  background: #fef3c7;
  border: 1px solid #fcd34d;
  color: #92400e;
}

.consumption-alert.neutral {
  background: #f3f4f6;
  border: 1px solid #d1d5db;
  color: #374151;
}

.alert-icon {
  font-size: 20px;
  flex-shrink: 0;
}

.alert-content strong {
  display: block;
  margin-bottom: 4px;
}

.alert-content p {
  margin: 0;
  font-size: 14px;
}

.consumption-footer {
  display: flex;
  justify-content: space-around;
  gap: 16px;
  margin-top: 16px;
  padding-top: 16px;
  border-top: 1px solid var(--color-border);
}

.legend-item {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  color: var(--color-text-secondary);
}

.legend-color {
  width: 16px;
  height: 16px;
  border-radius: 3px;
  flex-shrink: 0;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .chart-header {
    gap: 0.75rem;
  }
  
  .usage-stats {
    font-size: 0.875rem;
  }
  
  .usage-percentage {
    font-size: 1rem;
  }
  
  .time-toggle {
    width: 100%;
    justify-content: center;
  }
  
  .chart-footer {
    flex-direction: column;
    gap: 0.5rem;
  }
  
  .consumption-footer {
    flex-direction: column;
    gap: 8px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/ConsumptionChart.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,8BAA8B;EAC9B,6BAA6B;EAC7B,gBAAgB;EAChB,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,4CAA4C;EAC5C,8BAA8B;EAC9B,gBAAgB;EAChB,6BAA6B;EAC7B,gCAAgC;EAChC,qCAAqC;EACrC,+BAA+B;EAC/B,eAAe;EACf,sCAAsC;EACtC,4BAA4B;AAC9B;;AAEA;EACE,mCAAmC;EACnC,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,kCAAkC;EAClC,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,0BAA0B;EAC1B,qCAAqC;EACrC,+BAA+B;EAC/B,qCAAqC;AACvC;;AAEA;EACE,4CAA4C;EAC5C,8BAA8B;EAC9B,gBAAgB;EAChB,gCAAgC;EAChC,uBAAuB;EACvB,YAAY;EACZ,+BAA+B;EAC/B,eAAe;EACf,sCAAsC;EACtC,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,iCAAiC;AACnC;;AAEA;EACE,YAAY;EACZ,uCAAuC;EACvC,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,8BAA8B;EAC9B,kCAAkC;EAClC,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,4CAA4C;EAC5C,+BAA+B;EAC/B,8BAA8B;EAC9B,gBAAgB;EAChB,kDAAkD;EAClD,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,0BAA0B;EAC1B,qCAAqC;EACrC,+BAA+B;EAC/B,oBAAoB;EACpB,qCAAqC;AACvC;;AAEA;EACE,4CAA4C;EAC5C,8BAA8B;EAC9B,gBAAgB;EAChB,gCAAgC;EAChC,uBAAuB;EACvB,YAAY;EACZ,+BAA+B;EAC/B,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,2BAA2B;EAC3B,iCAAiC;AACnC;;AAEA;EACE,YAAY;EACZ,uCAAuC;EACvC,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,iBAAiB;EACjB,qCAAqC;EACrC,+BAA+B;EAC/B,0BAA0B;EAC1B,qCAAqC;AACvC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,iBAAiB;EACjB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,8BAA8B;EAC9B,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;EAChC,2CAA2C;AAC7C;;AAEA;EACE,+BAA+B;EAC/B,0CAA0C;AAC5C;;AAEA;EACE,gBAAgB;AAClB;;AAEA,yBAAyB;AACzB;EACE,gCAAgC;EAChC,aAAa;EACb,mBAAmB;EACnB,wCAAwC;EACxC,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,kCAAkC;EAClC,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,SAAS;EACT,gBAAgB;EAChB,iBAAiB;EACjB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,cAAc;AAChB;;AAEA,2BAA2B;AAC3B;EACE;IACE,YAAY;EACd;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,uBAAuB;EACzB;;EAEA;IACE,sBAAsB;IACtB,WAAW;EACb;;EAEA;IACE,sBAAsB;IACtB,QAAQ;EACV;AACF","sourcesContent":[".consumption-chart-container {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n}\n\n.chart-header {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-md);\n  margin-bottom: var(--spacing-lg);\n}\n\n.chart-title-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 0.5rem;\n}\n\n.chart-title-row h4 {\n  font-size: var(--font-size-lg);\n  color: var(--color-secondary);\n  font-weight: 600;\n  margin: 0;\n  letter-spacing: -0.02em;\n}\n\n.chart-controls {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n}\n\n.year-selector {\n  padding: var(--spacing-sm) var(--spacing-md);\n  font-size: var(--font-size-sm);\n  font-weight: 600;\n  color: var(--color-secondary);\n  background: var(--color-card-bg);\n  border: 2px solid var(--color-border);\n  border-radius: var(--radius-sm);\n  cursor: pointer;\n  transition: all var(--transition-base);\n  box-shadow: var(--shadow-sm);\n}\n\n.year-selector:hover {\n  border-color: var(--color-gray-300);\n  transform: translateY(-1px);\n  box-shadow: var(--shadow-md);\n}\n\n.year-selector:focus {\n  outline: none;\n  border-color: var(--color-primary);\n  box-shadow: 0 0 0 3px rgba(255, 107, 53, 0.2);\n}\n\n.environment-toggle {\n  display: flex;\n  gap: var(--spacing-xs);\n  padding: var(--spacing-xs);\n  background: var(--color-bg-secondary);\n  border-radius: var(--radius-md);\n  border: 1px solid var(--color-border);\n}\n\n.env-btn {\n  padding: var(--spacing-sm) var(--spacing-md);\n  font-size: var(--font-size-sm);\n  font-weight: 600;\n  color: var(--color-text-primary);\n  background: transparent;\n  border: none;\n  border-radius: var(--radius-sm);\n  cursor: pointer;\n  transition: all var(--transition-base);\n  position: relative;\n}\n\n.env-btn:hover {\n  color: var(--color-primary);\n  background: var(--color-hover-bg);\n}\n\n.env-btn.active {\n  color: white;\n  background: var(--color-secondary-dark);\n  box-shadow: var(--shadow-sm);\n}\n\n.env-btn.active:hover {\n  background: #1a3a5c;\n}\n\n.usage-info {\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n}\n\n.usage-stats {\n  display: flex;\n  align-items: baseline;\n  gap: 0.5rem;\n  flex-wrap: wrap;\n}\n\n.year-stats {\n  display: flex;\n  align-items: baseline;\n  gap: 0.5rem;\n  margin-top: 0.5rem;\n  padding-top: 0.5rem;\n  border-top: 1px solid var(--color-border);\n}\n\n.usage-label {\n  font-size: var(--font-size-sm);\n  color: var(--color-text-secondary);\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n}\n\n.usage-value {\n  font-size: var(--font-size-base);\n  font-weight: 700;\n  color: var(--color-secondary);\n}\n\n.usage-value.approaching-limit {\n  color: var(--color-warning);\n}\n\n.usage-value.over-limit {\n  color: var(--color-danger);\n}\n\n.usage-percentage {\n  font-size: var(--font-size-lg);\n  font-weight: 700;\n  color: var(--color-success);\n}\n\n.usage-percentage.approaching-limit {\n  color: var(--color-warning);\n}\n\n.usage-percentage.over-limit {\n  color: var(--color-danger);\n}\n\n.usage-alert {\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-sm);\n  padding: var(--spacing-md) var(--spacing-lg);\n  border-radius: var(--radius-md);\n  font-size: var(--font-size-sm);\n  font-weight: 600;\n  animation: slideIn var(--transition-slow) ease-out;\n  box-shadow: var(--shadow-sm);\n}\n\n.usage-alert.warning {\n  background: #fef3c7;\n  color: #92400e;\n  border: 1px solid #fcd34d;\n}\n\n.usage-alert.critical {\n  background: #fee2e2;\n  color: #991b1b;\n  border: 1px solid #fca5a5;\n}\n\n.usage-alert svg {\n  flex-shrink: 0;\n}\n\n@keyframes slideIn {\n  from {\n    opacity: 0;\n    transform: translateY(-10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.time-toggle {\n  display: flex;\n  gap: var(--spacing-xs);\n  padding: var(--spacing-xs);\n  background: var(--color-bg-secondary);\n  border-radius: var(--radius-md);\n  align-self: flex-end;\n  border: 1px solid var(--color-border);\n}\n\n.toggle-btn {\n  padding: var(--spacing-sm) var(--spacing-md);\n  font-size: var(--font-size-sm);\n  font-weight: 600;\n  color: var(--color-text-primary);\n  background: transparent;\n  border: none;\n  border-radius: var(--radius-sm);\n  cursor: pointer;\n  transition: all var(--transition-base);\n}\n\n.toggle-btn:hover {\n  color: var(--color-primary);\n  background: var(--color-hover-bg);\n}\n\n.toggle-btn.active {\n  color: white;\n  background: var(--color-secondary-dark);\n  box-shadow: var(--shadow-sm);\n}\n\n.toggle-btn.active:hover {\n  background: #1a3a5c;\n}\n\n.chart-container {\n  flex: 1;\n  position: relative;\n  min-height: 300px;\n  background: var(--color-bg-secondary);\n  border-radius: var(--radius-md);\n  padding: var(--spacing-lg);\n  border: 1px solid var(--color-border);\n}\n\n.chart-container canvas {\n  max-height: 350px;\n}\n\n.chart-footer {\n  display: flex;\n  gap: 2rem;\n  margin-top: 1rem;\n  padding-top: 1rem;\n  border-top: 1px solid var(--color-border);\n}\n\n.threshold-indicator {\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-sm);\n  font-size: var(--font-size-xs);\n  color: var(--color-text-secondary);\n  font-weight: 500;\n}\n\n.threshold-line {\n  width: 24px;\n  height: 3px;\n  border-radius: 1px;\n}\n\n.threshold-line.warning {\n  background: var(--color-warning);\n  box-shadow: 0 0 4px rgba(245, 158, 11, 0.5);\n}\n\n.threshold-line.critical {\n  background: var(--color-danger);\n  box-shadow: 0 0 4px rgba(239, 68, 68, 0.5);\n}\n\n.threshold-label {\n  font-weight: 500;\n}\n\n/* New component styles */\n.consumption-container {\n  background: var(--color-card-bg);\n  padding: 24px;\n  border-radius: 12px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n}\n\n.consumption-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 20px;\n}\n\n.consumption-header h3 {\n  font-size: 18px;\n  font-weight: 600;\n  color: var(--color-text-primary);\n  margin: 0;\n}\n\n.year-selector-container {\n  display: flex;\n  align-items: center;\n}\n\n.no-data-message {\n  text-align: center;\n  color: var(--color-text-secondary);\n  padding: 40px 20px;\n  font-size: 14px;\n}\n\n.usage-stat {\n  display: flex;\n  justify-content: space-between;\n  align-items: baseline;\n  padding: 8px 0;\n}\n\n.usage-value.danger {\n  color: #dc3545;\n}\n\n.usage-value.warning {\n  color: #f59e0b;\n}\n\n.usage-value.success {\n  color: #28a745;\n}\n\n.usage-value.neutral {\n  color: #6b7280;\n}\n\n.usage-value.info {\n  color: #3b82f6;\n  font-style: italic;\n}\n\n.trend-detail {\n  font-size: 12px;\n  color: var(--color-text-secondary);\n  margin-left: 4px;\n}\n\n.consumption-alert {\n  border-radius: 8px;\n  padding: 12px 16px;\n  margin-bottom: 16px;\n  display: flex;\n  gap: 12px;\n  align-items: start;\n}\n\n.consumption-alert.danger {\n  background: #fee2e2;\n  border: 1px solid #fca5a5;\n  color: #991b1b;\n}\n\n.consumption-alert.info {\n  background: #dbeafe;\n  border: 1px solid #93c5fd;\n  color: #1e40af;\n}\n\n.consumption-alert.success {\n  background: #dcfce7;\n  border: 1px solid #86efac;\n  color: #14532d;\n}\n\n.consumption-alert.warning {\n  background: #fef3c7;\n  border: 1px solid #fcd34d;\n  color: #92400e;\n}\n\n.consumption-alert.neutral {\n  background: #f3f4f6;\n  border: 1px solid #d1d5db;\n  color: #374151;\n}\n\n.alert-icon {\n  font-size: 20px;\n  flex-shrink: 0;\n}\n\n.alert-content strong {\n  display: block;\n  margin-bottom: 4px;\n}\n\n.alert-content p {\n  margin: 0;\n  font-size: 14px;\n}\n\n.consumption-footer {\n  display: flex;\n  justify-content: space-around;\n  gap: 16px;\n  margin-top: 16px;\n  padding-top: 16px;\n  border-top: 1px solid var(--color-border);\n}\n\n.legend-item {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 13px;\n  color: var(--color-text-secondary);\n}\n\n.legend-color {\n  width: 16px;\n  height: 16px;\n  border-radius: 3px;\n  flex-shrink: 0;\n}\n\n/* Responsive adjustments */\n@media (max-width: 768px) {\n  .chart-header {\n    gap: 0.75rem;\n  }\n  \n  .usage-stats {\n    font-size: 0.875rem;\n  }\n  \n  .usage-percentage {\n    font-size: 1rem;\n  }\n  \n  .time-toggle {\n    width: 100%;\n    justify-content: center;\n  }\n  \n  .chart-footer {\n    flex-direction: column;\n    gap: 0.5rem;\n  }\n  \n  .consumption-footer {\n    flex-direction: column;\n    gap: 8px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
